import React from 'react';
import { colors } from '@styles/colors';

function LoadingOverlay({ visible = false, size = '4.2vh', thickness = '0.8vh' }) {
  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(41, 217, 197, 0.15)',
      backdropFilter: 'blur(1px)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      {/* Keyframes para el spinner */}
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
      <div style={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: `${thickness} solid ${colors.gray200}`,
        borderTopColor: colors.primary,
        animation: 'spin 0.8s linear infinite'
      }} />
    </div>
  );
}

export default LoadingOverlay;